/*!
 * Copyright (c) 2017-present Cliqz GmbH. All rights reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
/* eslint-disable prettier/prettier */
export default [
  "securepubads.g.doubleclick",
  "googlesyndication",
  "imasdk.googleapis",
  "googletagmanager",
  ".cloudfront.net",
  ".actonservice",
  ".rsc.cdn77.",
  "doubleclick",
  "marketing.",
  "analytics",
  "smetrics.",
  ".website",
  "metrics.",
  "digital",
  ".co.uk",
  "a8clk.",
  "stats.",
  "a8cv.",
  "media",
  "space",
  "track",
  ".com",
  ".net",
  ".xyz",
  "ight",
  "www.",
  ".de",
  ".io",
  ".jp",
  "aff",
  "app",
  "cdn",
  "new",
  "pro",
  "web",
  ".b",
  ".c",
  ".f",
  ".h",
  ".k",
  ".m",
  ".n",
  ".p",
  ".t",
  ".v",
  ".w",
  "a1",
  "a8",
  "ab",
  "ac",
  "ad",
  "af",
  "ag",
  "ah",
  "ai",
  "ak",
  "al",
  "am",
  "an",
  "ap",
  "ar",
  "as",
  "at",
  "au",
  "av",
  "aw",
  "ax",
  "ay",
  "az",
  "be",
  "bl",
  "bo",
  "br",
  "bu",
  "ca",
  "ce",
  "ch",
  "ci",
  "ck",
  "cl",
  "cr",
  "ct",
  "cu",
  "da",
  "de",
  "di",
  "do",
  "dr",
  "ds",
  "du",
  "dy",
  "e-",
  "eb",
  "ec",
  "ed",
  "ef",
  "eg",
  "ek",
  "el",
  "em",
  "en",
  "ep",
  "er",
  "es",
  "et",
  "eu",
  "ev",
  "ew",
  "ex",
  "ey",
  "fe",
  "fi",
  "fl",
  "fo",
  "fr",
  "ge",
  "gh",
  "gl",
  "go",
  "gr",
  "gu",
  "he",
  "ho",
  "ia",
  "ib",
  "ic",
  "id",
  "ie",
  "if",
  "ig",
  "ik",
  "il",
  "im",
  "in",
  "ip",
  "ir",
  "is",
  "it",
  "iv",
  "ix",
  "iz",
  "jo",
  "ks",
  "la",
  "ld",
  "le",
  "li",
  "lo",
  "lu",
  "ly",
  "ma",
  "me",
  "mo",
  "mp",
  "my",
  "nd",
  "ne",
  "no",
  "ob",
  "of",
  "ok",
  "ol",
  "om",
  "on",
  "oo",
  "op",
  "or",
  "ot",
  "ou",
  "ow",
  "ph",
  "pl",
  "po",
  "pr",
  "qu",
  "re",
  "ro",
  "ru",
  "s-",
  "sc",
  "se",
  "sh",
  "si",
  "sk",
  "sm",
  "sn",
  "so",
  "sp",
  "ss",
  "st",
  "su",
  "sw",
  "sy",
  "t-",
  "ta",
  "te",
  "th",
  "ti",
  "tn",
  "to",
  "tr",
  "ts",
  "tu",
  "tw",
  "ty",
  "ub",
  "ul",
  "um",
  "un",
  "up",
  "ur",
  "us",
  "ut",
  "ve",
  "vi",
  "we",
  "-",
  ".",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z"
];